// Save guest details (only for non-logged-in users)
export const saveGuestDetails = (formData, isLoggedIn) => {
  if (isLoggedIn) return; 
  
  const guestData = {
    phoneNumber: formData.phoneNumber || "",
    name: formData.name || "",
    email: formData.email || "",
    houseNo: formData.houseNo || "",
    area: formData.area || "",
    landmark: formData.landmark || "",
    pincode: formData.pincode || "",
    timestamp: new Date().toISOString(),
  };
  
  localStorage.setItem("guestCheckoutDetails", JSON.stringify(guestData));
};

// Load saved guest details (only for non-logged-in users)
export const loadGuestDetails = (isLoggedIn) => {
  if (isLoggedIn) return {};
  
  try {
    const savedData = localStorage.getItem("guestCheckoutDetails");
    return savedData ? JSON.parse(savedData) : {};
  } catch (error) {
    return {};
  }
};

// Check if guest details exist
export const hasGuestDetails = () => {
  try {
    const savedData = localStorage.getItem("guestCheckoutDetails");
    return savedData ? true : false;
  } catch (error) {
    return false;
  }
};

// Clear saved guest details
export const clearGuestDetails = () => {
  try {
    localStorage.removeItem("guestCheckoutDetails");
  } catch (error) {
    console.error("Error clearing guest details:", error);
  }
};